import { Stack } from '@mui/material'
import { FC } from 'react'
import { useParams } from 'react-router-dom'
import { useLocation, useLocationCameras } from '../../../../api/apiQueries'
import { Skeleton } from '../../../../components/Skeleton/Skeleton'
import { isOdmonEnrolledCamera } from '../../../../utils/utils'
import { FeatureTable } from './FeatureTable'
import { withSopFeatureRow } from './utils'

export const FeatureViewerTab: FC = () => {
  const { sid: locationId } = useParams()
  const locationQuery = useLocation(locationId)
  const camerasQuery = useLocationCameras(locationId)

  const location = locationQuery.data
  const cameras = camerasQuery.data ?? []
  const isLoading = locationQuery.isLoading || camerasQuery.isLoading
  const hasEligiblePlan = location?.monitoring?.serviceStatus?.outdoorMonitoring?.hasEligiblePlan
  const features = location?.features && withSopFeatureRow(location.features, cameras.some(isOdmonEnrolledCamera), hasEligiblePlan)

  return (
    <Stack>
      {!isLoading && features ? (
        <FeatureTable features={features} />
      ) : (
        <Skeleton isLoading={isLoading} variant={'rounded'} sx={{ height: '4rem', width: '100%' }} />
      )}
    </Stack>
  )
}
